import { render, staticRenderFns } from "./EditCanvasPage.vue?vue&type=template&id=5bb5133e"
import script from "./EditCanvasPage.vue?vue&type=script&lang=js"
export * from "./EditCanvasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports